import { render, staticRenderFns } from "./aiSuggestDialogue.vue?vue&type=template&id=e911d2b6&scoped=true"
import script from "./aiSuggestDialogue.vue?vue&type=script&lang=js"
export * from "./aiSuggestDialogue.vue?vue&type=script&lang=js"
import style0 from "./aiSuggestDialogue.vue?vue&type=style&index=0&id=e911d2b6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e911d2b6",
  null
  
)

export default component.exports